import { Component, Input } from '@angular/core';

@Component({
  selector: 'g99-lib-notification-skeleton',
  templateUrl: './notification-skeleton.component.html',
  styleUrl: './notification-skeleton.component.scss',
  standalone: false,
})
export class NotificationSkeletonComponent {
  // Public members first
  @Input() public count = 3;
  @Input() public showMeta = true;

  // Protected members second
  protected get skeletonItems(): number[] {
    return Array(this.count).fill(0);
  }
}
